import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { Control } from "../../models/riesgo/Control";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";
import { Consecuencias } from "./Consecuencias";
import { ControlesOrden } from "./ControlesOrden";

export const ControlImplementado = ({ riesgo, id, toast, permss, generic, seccion, nextPrev, handleNext, registrar, funcionalidades }) => {
    const omodel = new Control();
    const matrizSrv = new MonitoreoService();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model);
    const [registros, setRegistros] = useState(null);
    const [item, setItem] = useState(null);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [dialogConsecuencia, setDialogConsecuencia] = useState(false);
    const [dialogControl, setDialogControl] = useState(false);
    const [dialogOrdenarControl, setDialogOrdenarControl] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [lista, setLista] = useState(null);
    const [titulo, setTitulo] = useState(null);
    const [campo, setCampo] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [listar, setListar] = useState(null);
    const [seleccionar, setSeleccionar] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inComplete } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        //setLista(catalogo);
        consultar();
        loadLazyData();
    }, [lazyParams]);

    const consultar = () => {
        const ids = id ?? getValues('id') ?? 0;
        matrizSrv.consultar(`${ids}/${riesgo?.id}/${seccion}`, 'matriz-riesgo-detalle/consulta').then(res => {
            setCatalogos(res.data?.catalogos);
        });
    }

    const loadLazyData = () => {
        setLoading(true);
        const _lazyParams = lazyParams;
        _lazyParams.idp = id;
        matrizSrv.listado('matriz-riesgo-control/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const openNew = () => {
        reset(defaultValues);
        setDialogControl(true);
    }

    const onSubmit = (data) => {
        data.idp = id;
        if (getValues('id') == null) {
            matrizSrv.nuevo(data, 'matriz-riesgo-control/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogControl(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            matrizSrv.editar(data, 'matriz-riesgo-control/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogControl(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editar = () => {
        matrizSrv.consultar(`${item?.id}/${id}`, 'matriz-riesgo-control/consulta').then(res => {
            const _control = res.data;
            reset(generic.renewValues(_control, omodel.model));
            setDialogControl(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            group: 'eliminar-riesgo',
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        matrizSrv.eliminar(`${item?.id}/${id}`, 'matriz-riesgo-control/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const customDialogHeader = () => {
        return (
            <div>
                <i className="pi pi-user-edit icon-header" />
                <span className="title-header">
                    {getValues('id') == null ? " Nuevo " : " Editar "}
                </span>
            </div>
        );
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} />}
                    <span className="font-bold">CONTROLES</span>
                </div>
                <div className="flex align-items-center gap-2">
                    <Button icon="pi pi-sort" className="p-button-secondary" tooltip="Ordenar controles" tooltipOptions={{ position: 'left' }} onClick={() => setDialogOrdenarControl(true)} style={{ height: '2.5rem' }} />
                    <span className="font-bold">ORDEN</span>
                </div>
            </div>
        );
    }

    const seleccion = (info, listado) => {
        if (listar === 'solo') {
            const _catalogos = catalogos;
            _catalogos[tipo] = listado;
            setCatalogos(_catalogos);
        } else {
            setValue(campo, info);
            setDialogCriterio(false);
            setTipo(null);
            setSeleccionar(null);
            setListar(null);
        }
    }

    const actualizarCatalogo = (tipo, nuevoListado, padreId = null, nuevoId = null) => {
        setCatalogos(prev => ({ ...prev, [tipo]: nuevoListado }));
        if (padreId && nuevoId) {
            const map = {
                'MTR_RIESGO_TIPO_CONTROL': 'tipo_control',
                'MTR_RIESGO_EJECUCION_CONTROL': 'ejecucion',
                'MTR_RIESGO_FRECUENCIA_CONTROL': 'frecuencia',
                'MTR_RIESGO_SOLIDEZ_CONTROL': 'solidez',
                'MTR_RIESGO_EFECTIVIDAD_CONTROL': 'efectividad',
            };
            const fieldName = map[tipo];
            const valorActual = getValues(fieldName); // Valor aún almacenado en el front
            if (valorActual?.cat_id === padreId) { // Coincide con el editado
                const nuevoValor = nuevoListado.find(item => item.cat_id === nuevoId);
                setValue(fieldName, nuevoValor);
            }
        }
        loadLazyData(); // Refrescamos la tabla tanto si edita un padre como si edita un valor
    };

    const search = (event, tipo) => {
        if (!event.query.trim().length) {
            setLista([...lista]);
        } else {
            matrizSrv.autoListaMatriz(`matriz-riesgo-criterio/nbuscar/${tipo}`, event.query.toLowerCase(), riesgo?.id).then(res => {
                setLista(res.data);
            });
        }
    }

    const criterios = (opc, ccampo, lis = 'solo', sel = false) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setCampo(ccampo);
        setTipo(opc);
        setDialogCriterio(true);
        setSeleccionar(sel);
        setListar(lis);
    }

    const mostrarConsecuencia = (tipo, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setDialogConsecuencia(true);
        setTipo(tipo);
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
                {nextPrev('solo-control-ambos')}
            </Panel>

            <Dialog visible={dialogControl} header={customDialogHeader} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogControl(false);
            }}
                style={{ width: '600px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inComplete('implementado', lista, search, { hd: omodel.model.implementado.header, col: 11, obl: true, valor: 'MTR_RIESGO_CTRL_IMPLEMENTADO', lab: 'nombre' })}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '3.2rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Registrar y Buscar"
                                onClick={() => criterios('MTR_RIESGO_CTRL_IMPLEMENTADO', 'implementado', 'ninguno', true)} />
                        </div>

                        {inDrop('responsable', catalogos?.MTR_RIESGO_ACTOR_INTERNO, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '3.2rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Registrar y Buscar"
                                onClick={() => criterios('MTR_RIESGO_ACTOR_INTERNO', 'responsable')} />
                        </div>

                        {inDrop('tipo_control', catalogos?.MTR_RIESGO_TIPO_CONTROL, { lab: 'nombre' }, 5)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Tipo de Control"
                                onClick={() => mostrarConsecuencia('MTR_RIESGO_TIPO_CONTROL', 'tipo_control')} />
                        </div>

                        {inDrop('ejecucion', catalogos?.MTR_RIESGO_EJECUCION_CONTROL, { lab: 'nombre' }, 5)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Tipo de Ejecución de Control"
                                onClick={() => mostrarConsecuencia('MTR_RIESGO_EJECUCION_CONTROL', 'ejecucion')} />
                        </div>

                        {inDrop('frecuencia', catalogos?.MTR_RIESGO_FRECUENCIA_CONTROL, { lab: 'nombre' }, 5)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Frecuencia del Control"
                                onClick={() => mostrarConsecuencia('MTR_RIESGO_FRECUENCIA_CONTROL', 'frecuencia')} />
                        </div>

                        {inDrop('solidez', catalogos?.MTR_RIESGO_SOLIDEZ_CONTROL, { lab: 'nombre' }, 5)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Solidez de los Controles"
                                onClick={() => mostrarConsecuencia('MTR_RIESGO_SOLIDEZ_CONTROL', 'solidez')} />
                        </div>

                        {inDrop('efectividad', catalogos?.MTR_RIESGO_EFECTIVIDAD_CONTROL, { lab: 'nombre' }, 11)}
                        <div className="field col-1" style={{ display: 'flex', flexDirection: 'column', marginTop: '1.85rem' }}>
                            <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar Efectividad de la implementación de los Controles"
                                onClick={() => mostrarConsecuencia('MTR_RIESGO_EFECTIVIDAD_CONTROL', 'efectividad')} />
                        </div>

                    </div>
                    {generic.buttonsForms(setDialogControl)}
                </form>
            </Dialog>

            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogCriterio(false);
            }}
                style={{ maxWidth: '500px' }}>
                <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={seleccionar} listar={listar} funcionalidades={funcionalidades} />
            </Dialog>

            <Dialog visible={dialogConsecuencia} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogConsecuencia(false);
            }}
                style={{ maxWidth: '500px' }}>
                {tipo !== null &&
                    <Consecuencias toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} id={id} funcionalidades={funcionalidades} actualizarCatalogo={actualizarCatalogo} />}
            </Dialog>

            <Dialog visible={dialogOrdenarControl} header={<span><i className="pi pi-list mr-2"></i> Actualizar el orden de los controles</span>} modal className="dialog-personalizado" onHide={() => { setDialogOrdenarControl(false); }} style={{ width: '700px' }}>
                <ControlesOrden matrizDetalleId={id} toast={toast} permss={permss} generic={generic} onClose={() => { setDialogOrdenarControl(false); loadLazyData() }} />
            </Dialog>
        </>
    )
}
